/* Copy da página de chat de suporte (ADR-0352/0811): trilha, estado de conexão do websocket e
   mensagem de ticket não encontrado. `ChatHeader`/`ChatThread`/`ChatComposer`/`TypingIndicator`/
   `TicketContextPanel` são componentes externos — fora do escopo desta área. */
import type { Bilingual } from '../bilingual.js';
import { useBilingual } from '../locale-provider.js';

interface SupportChatContent {
  readonly breadcrumbAriaLabel: string;
  readonly supportLabel: string;
  readonly ticketLabel: string;
  readonly notFoundMessage: string;
  readonly reconnecting: string;
  readonly connectionLost: string;
}

const SUPPORT_CHAT_CONTENT: Bilingual<SupportChatContent> = {
  'pt-BR': {
    breadcrumbAriaLabel: 'Trilha',
    supportLabel: 'Suporte',
    ticketLabel: 'Ticket',
    notFoundMessage: 'Ticket não encontrado.',
    reconnecting: 'Reconectando ao chat…',
    connectionLost: 'Conexão perdida. Recarregue a página.',
  },
  'en-US': {
    breadcrumbAriaLabel: 'Breadcrumb',
    supportLabel: 'Support',
    ticketLabel: 'Ticket',
    notFoundMessage: 'Ticket not found.',
    reconnecting: 'Reconnecting to chat…',
    connectionLost: 'Connection lost. Reload the page.',
  },
};

export const useSupportChatContent = (): SupportChatContent => useBilingual(SUPPORT_CHAT_CONTENT);
